import * as React from "react";
import Card from "../components/Card";

export interface DrinkProps {}

const Drink: React.FC<DrinkProps> = props => {
  return (
    <div>
      <Card title="Drinks" titleBackgroundColor="#FCBA6A"></Card>
      <Card title="Beer">
        <h2>Chang</h2>
        <h2>Leo</h2>
      </Card>

      <Card title="Non-alcoholic">
        <h2>Coca Cola</h2>
        <h2>Sprite</h2>
        <h2>Fanta</h2>
        <h2>Ice Tea</h2>
        <h2>Coconut Drink</h2>
      </Card>

      <Card title="Coffee">
        <h2>Espresso</h2>
        <h2>Americano</h2>
        <h2>Cappuccino</h2>
        <h2>Latte</h2>
      </Card>

      <Card title="Fruit Shakes">
        <h2>Water Melon</h2>
        <h2>Pineapple</h2>
        <h2>Banana</h2>
        <h2>Coconut</h2>
        <h2>Mango</h2>
      </Card>

      <Card title="Cocktails">
        <h2>Espresso Martini</h2>
        <h2>Negroni</h2>
        <h2>Aperol Spritz</h2>
        <h2>Bronn Derby</h2>
        <h2>Bees Knees</h2>
        <h2>God Father</h2>
        <h2>Manhatan</h2>
        <h2>Brandy Flip</h2>
        <h2>Mojito</h2>
        <h2>Mai Tai</h2>
      </Card>

      <Card title="Shots">
        <h2>Tequila</h2>
        <h2>Vodka</h2>
        <h2>Sang Som</h2>
        <h2>B-52</h2>
      </Card>
    </div>
  );
};

export default Drink;
